import { useAlertsState } from '@/components/Alertsv2/useAlertState'

interface UseCheckHasAlertProps {
  key: string
  forceRefetch?: boolean
}

export function useCheckHasAlert({ key, forceRefetch = false }: UseCheckHasAlertProps) {
  const { alerts } = useAlertsState(forceRefetch)

  const hasAlert =
    alerts.filter((alert) => {
      const isNoStatus = alert.status === 'no-status'
      const isKeyOrMessageMatch = alert.key === key || alert.message === key
      return isNoStatus && isKeyOrMessageMatch
    }).length > 0

  return {
    key,
    hasAlert,
  }
}
